import { lazy } from "react";

//components imports
import Vehicle from "modules/vehicle";
import Company from "modules/company";
import Testimonial from "modules/testimonial";
import ROUTE_NAMES from "./routeNames";
import PrivateRoute from "./privateRoute";
import MainLayout from "layout/mainLayout";
import Order from "modules/orderManagement";
import Coupon from "modules/coupon";
import CreateCoupon from "modules/coupon/createCoupon";
import AddUser from "modules/userManagement/addUser";
import EditUser from "modules/userManagement/editUser";
import RoutesContainer from "components/routesContainer";
import UtilityManagement from "modules/utilityManagement";
import ServiceManagement from "modules/serviceManagement";
import AddServiceTypes from "modules/serviceManagement/addService";
import ServiceDetailsPage from "modules/serviceManagement/serviceDetails";
import CreateOrder from "modules/orderManagement/createOrder";
import UserDetail from "../modules/userManagement/userDetail/index";
import ServicePricingManagement from "modules/servicePricingManagement";
import SubAdminRoute from "./subAdminRoute";
import UnauthorizedUser from "modules/auth/UnauthorizedUser";
import { Navigate } from "react-router-dom";
import { SERVICE_CATEGORY, SERVICE_CATEGORY_SLUG } from "utils/serviceCategory";
import Feedback from "modules/feedback";

const createServiceCategoryChildren = () => [
  {
    index: true,
    element: (
      <Navigate to={SERVICE_CATEGORY_SLUG[SERVICE_CATEGORY.CAR]} replace />
    ),
  },
  ...Object.values(SERVICE_CATEGORY_SLUG).map((slug) => ({
    path: slug,
    element: <></>,
  })),
];
//pages import
const Dashboard = RoutesContainer(lazy(() => import("modules/dashboard")));
const UserManagement = RoutesContainer(
  lazy(() => import("modules/userManagement"))
);
const OrderDetail = RoutesContainer(
  lazy(() => import("modules/orderManagement/orderDetail"))
);
const CouponDetail = RoutesContainer(
  lazy(() => import("modules/coupon/couponDetail"))
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: ROUTE_NAMES.BASE_ROUTE,
  element: <MainLayout />,
  children: [
    {
      path: ROUTE_NAMES.MAIN_ROUTES.DASHBOARD,
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.BASE,

      element: (
        <PrivateRoute>
          <UserManagement />
        </PrivateRoute>
      ),

      children: [
        {
          index: true,
          element: <Navigate to={ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.CUSTOMERS} replace />,
        },
        {
          path: ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.CUSTOMERS,
          element: <></>,
        },
        {
          path: ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.FRANCHISES,
          element: <></>,
        },
        {
          path: ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.COORDINATORS,
          element: <></>,
        },
        {
          path: ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.SERVICE_PARTNERS,
          element: <></>,
        },
      ],
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ADD_USER,
      element: (
        <PrivateRoute>
          <AddUser />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.EDIT_USER,
      element: (
        <PrivateRoute>
          <EditUser />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.USER_DETAIL,
      element: (
        <PrivateRoute>
          <UserDetail />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.UTILITY_MANAGEMENT,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <UtilityManagement />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.SERVICE_MANAGEMENT,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <ServiceManagement />
          </SubAdminRoute>
        </PrivateRoute>
      ),
      children: createServiceCategoryChildren(),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ADD_SERVICE,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <AddServiceTypes />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.SERVICE_DETAIL,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <ServiceDetailsPage />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.SERVICE_PRICING_MANAGEMENT,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <ServicePricingManagement />
          </SubAdminRoute>
        </PrivateRoute>
      ),
      children: createServiceCategoryChildren(),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ORDER,
      element: (
        <PrivateRoute>
          <Order />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CREATE_ORDER,
      element: (
        <PrivateRoute>
          <CreateOrder />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.EDIT_ORDER,
      element: (
        <PrivateRoute>
          <CreateOrder />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ORDER_DETAIL,
      element: (
        <PrivateRoute>
          <OrderDetail />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.COMPANIES,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <Company />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: "/cars",
      element: <Navigate to={ROUTE_NAMES.MAIN_ROUTES.VEHICLE} replace />,
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.VEHICLE,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <Vehicle />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.TESTIMONIAL,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <Testimonial />
          </SubAdminRoute>
        </PrivateRoute>
      ),
      children: createServiceCategoryChildren(),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.COUPON,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <Coupon />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CREATE_COUPON,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <CreateCoupon />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.EDIT_COUPON,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <CreateCoupon />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.COUPON_DETAIL,
      element: (
        <PrivateRoute>
          <SubAdminRoute>
            <CouponDetail />
          </SubAdminRoute>
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.UNAUTHORIZED,
      element: (
        <PrivateRoute>
          <UnauthorizedUser />
        </PrivateRoute>
      )
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.FEEDBACK,
      element: (
        <PrivateRoute>
          <Feedback />
        </PrivateRoute>
      )
    }

  ],
};

export default MainRoutes;
